export default __webpack_public_path__ + "chevron-sign-to-right.png";